<div class="navigation-cards">
  <ng-container *ngIf="(user$ | async) as user">
    <ng-container *ngFor="let link of navLink">
      <mat-card class="card"
                *ngIf="hideTab(user, link.roles)"
                routerLink="/{{link.link}}">
        <mat-icon>{{link.icon}}</mat-icon>
        <mat-card-title>{{link.label}}</mat-card-title>
      </mat-card>
    </ng-container>
  </ng-container>
</div>
